<template>

          <div class="col-md-12">
            <div class="row list">
                <div class="col-lg-12 col-md-12">
                    <div class="card m-b-30">

                        <div class="card-body">
                          <strong>  {{clients.data.total}}</strong> Enrollees with Null Sectors
                          <div class="table-responsive">
                              <table class="table align-td-middle table-card">
                                  <thead>
                                  <tr>
                                      <th>Name</th>
                                      <th>ID Number</th>
                                      <th>Date</th>
                                      <th>Category of Vulnerable Group</th>
                                      <th>Action</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="client in clients.data.data" v-bind:key="client.id">
                                      <td>
                                        <router-link :to="{ path: '/client/'+client.id, params: {} }">
                                        {{client.firstname}} {{client.lastname}} / {{client.phone_number}}
                                      </router-link>
                                      </td>
                                      <td>{{client.id_card_number}}-</td>
                                      <td>{{client.created_at}}</td>
                                      <td>{{client.category_of_vulnerable_group}}</td>
                                         <td>
                                           <select class="form-control"  v-model="client.sector" >
                                             <option  value="State Civil Servant Healthcare Plan">State Civil Servant Healthcare Plan</option>
                                             <option  value="State Equity Program">State Equity Program</option>
                                            <option  value="Basic Healthcare Provision Fund">Basic Healthcare Provision Fund</option>
                                            <option  value="Voluntary Contributors Healthcare Plan">Voluntary Contributors Healthcare Plan</option>
                                            <option  value="Voluntary Contributor">Voluntary Contributor</option>
                                            <option  value="Organized Community Healthcare Plan">Organized Community Healthcare Plan</option>
                                            <option  value="Oganized Private Sector Healthcare Plan">Oganized Private Sector Healthcare Plan</option>
                                        </select>

                                         </td>

                                      <td>

                                          <button type="button" @click="changeNumber(client)" class="btn btn-primary"
                                          style="margin-left:10px; margin-top:10px;" >
                                            <i class="fe fe-edit"></i></button>

                                      </td>
                                  </tr>


                                  </tbody>
                              </table>

                          </div>

                        </div>
                    </div>
                </div>



                <div class="vld-parent">
                     <loading :active.sync="isLoading"
                     loader="dots"
                     :can-cancel="false"
                     :is-full-page="fullPage"></loading>
                 </div>


            </div>
          </div>

</template>

<script>
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin

export default {
  components: {
    Loading
  },
  data(){
    return{
      isLoading: false,
      fullPage: true,
      states:"",
      clients:"",

    }
  },

  methods:{

    getClients(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/no-sector/90`)
                  .then(response => {
                      this.clients = response.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },

    changeNumber(client){
      this.isLoading = true
        this.axios.patch(`/api/v1/auth/change-sector/${client.id}`,{
          sector: client.sector
        })
                    .then(response => {
                        console.log(response)
                        this.getClients()
                        this.$toasted.success('Changed Successfully', {position: 'top-center', duration:3000 })
                        this.isLoading = false

                    })
                    .catch(error => {
                        console.error(error);
                        this.$toasted.error('Error!', {position: 'top-center', duration:3000 })
                        this.isLoading = false

                    })

    },


  },
  created(){
    this.getClients()
  }

}
</script>
